import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { Product } from '../../types/product';
interface ProductCardProps {
  product: Product;
}
export function ProductCard({
  product
}: ProductCardProps) {
  return <Link to={`/products/${product.slug}`} className="group flex h-full flex-col overflow-hidden rounded-[24px] border border-edge bg-coal transition-colors duration-150 hover:border-flame" data-id="element-212" data-mp="116mv5eba1ydo">
      <div className="relative overflow-hidden" data-id="element-213" data-mp="w579bk19znu8">
        <img src={product.image} alt={`${product.name} at Universal Packaging Industries, Umm Al Quwain`} loading="lazy" className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-out-strong group-hover:scale-[1.04]" data-id="element-214" data-mp="w5z5ox2p5plk" />
      </div>
      <div className="flex flex-1 flex-col p-6 text-center sm:text-left" data-id="element-215" data-mp="8gxskwix5q9y">
        <p className="text-xs font-bold uppercase tracking-[0.12em] text-flame" data-id="element-216" data-mp="dezbnhgchplf">{product.category}</p>
        <h3 className="mt-2 font-display text-[28px] font-bold uppercase leading-none text-chalk" data-id="element-217" data-mp="3n9vif66zar32">{product.name}</h3>
        <p className="mt-3 text-muted" data-id="element-218" data-mp="3iase5nytoow5">{product.line}</p>
        <span className="mt-auto flex items-center justify-center gap-3 pt-6 text-sm font-bold uppercase tracking-[0.06em] text-chalk sm:justify-between" data-id="element-219" data-mp="5p4dpxwvope">
          View Details
          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-flame text-flame transition-colors duration-150 group-hover:bg-flame group-hover:text-ink" data-id="element-220" data-mp="3rafgcbzdlyq9">
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-221" data-mp="2zizkdrbxiznd" />
          </span>
        </span>
      </div>
    </Link>;
}